import { hasMoney, money, billingError } from './billingDocument.js';
export const getApprovedVisitFinancialContext = (visit = {}) => {
    const rawTotal = visit?.final_customer_total ?? visit?.finalCustomerTotal;
    const finalTotal = hasMoney(rawTotal) ? money(rawTotal) : null;
    if (!Array.isArray(visit?.payments)) throw billingError('DOCUMENT_PAYMENTS_UNAVAILABLE');
    const payments = visit.payments;
    const confirmedPaid = payments
        .filter((payment) => payment?.confirmed !== false && !['pending', 'pending_confirmation', 'unconfirmed', 'reversed', 'cancelled'].includes(String(payment?.status || '').toLowerCase()))
        .reduce((sum, payment) => sum + money(payment?.arApplied ?? payment?.ar_applied, 'الدفعة المخصصة للذمة'), 0);
    return {
        visit_id: visit?.id,
        finalized_at: visit?.finalizedAt ?? visit?.finalized_at ?? null,
        financial_state: visit?.financialState ?? visit?.financial_state ?? 'open',
        final_customer_total: finalTotal,
        confirmed_paid: money(confirmedPaid),
        payments,
    };
};
